import React from 'react';

import { TypographyWithTooltip } from '@lyearn/molecules';
import { TypographyType } from '@lyearn/ui';
import { getFileCategory } from '@/features/media/utils';
import getFileNameAndExtension from '@/modules/classrooms/modules/files/utils/getFileNameAndExtension';
import { MediaKindEnum } from '@/types/schema';

import { useMediaContext } from '../context';

interface MediaTypeProps extends TypographyType {}

function MediaType(props: MediaTypeProps) {
  const { media } = useMediaContext();
  const category = getFileCategory(media.mimeType!);
  const { extension } = getFileNameAndExtension(media.name);
  let linkText = undefined;
  if (media.kind === MediaKindEnum.WebLink) {
    linkText = 'Web Link';
  } else if (media.kind === MediaKindEnum.YoutubeLink) {
    linkText = 'Youtube Link';
  }

  return (
    <TypographyWithTooltip
      className="uppercase"
      color="text-text-secondary"
      numberOfLines={1}
      variant="body-short-03"
      {...props}>
      {linkText || extension || category}
    </TypographyWithTooltip>
  );
}

export default React.memo(MediaType);
